export const ACTION_TYPES = Object.freeze({
  GUIDANCE: 'guidance',
  READ: 'read',
  WRITE: 'write',
  HANDOFF: 'handoff',
  EXTERNAL: 'external',
  DANGEROUS: 'dangerous',
  MIXED: 'mixed',
  UNKNOWN: 'unknown',
});

export const EFFECT_ACTION_TYPES = Object.freeze([
  ACTION_TYPES.WRITE,
  ACTION_TYPES.HANDOFF,
  ACTION_TYPES.EXTERNAL,
  ACTION_TYPES.DANGEROUS,
]);

const knownActionTypes = new Set([ACTION_TYPES.READ, ...EFFECT_ACTION_TYPES]);

export const normalizeActionType = riskLevel => {
  const normalizedRiskLevel = String(riskLevel || '').toLowerCase();
  return knownActionTypes.has(normalizedRiskLevel)
    ? normalizedRiskLevel
    : ACTION_TYPES.UNKNOWN;
};

export const actionTypeForScenario = (scenario = {}, actions = []) => {
  if (scenario.action_type) return scenario.action_type;

  const toolIds = Array.isArray(scenario.tools) ? scenario.tools : [];
  if (toolIds.length === 0) return ACTION_TYPES.GUIDANCE;

  const actionsById = new Map(
    actions.map(action => [
      String(action.id),
      normalizeActionType(action.risk_level),
    ])
  );
  const riskLevels = [
    ...new Set(
      toolIds.map(toolId => actionsById.get(String(toolId))).filter(Boolean)
    ),
  ];
  if (riskLevels.length > 1) return ACTION_TYPES.MIXED;
  if (riskLevels.length === 1) return riskLevels[0];
  return ACTION_TYPES.UNKNOWN;
};

export const isScenarioActionTypeCompatible = (scenario = {}, actions = []) => {
  if (scenario.action_type_compatible === false) return false;
  return actionTypeForScenario(scenario, actions) !== ACTION_TYPES.MIXED;
};

export const scenarioRiskLevels = (scenario = {}, actions = []) => {
  if (Array.isArray(scenario.risk_levels)) return scenario.risk_levels;

  const actionsById = new Map(
    actions.map(action => [
      String(action.id),
      normalizeActionType(action.risk_level),
    ])
  );

  return [
    ...new Set(
      (scenario.tools || [])
        .map(toolId => actionsById.get(String(toolId)))
        .filter(type => type && type !== ACTION_TYPES.UNKNOWN)
    ),
  ];
};
